export { tasksReducer } from './tasks.reducer';
export { watchTasks } from './tasks.saga';

import {
    createTask,
    getTasks,
    getTaskById,
    updateTask,
    deleteTask,
    bulkUpdateTaskStatus,
    bulkAssignTask,
    bulkDeleteTasks,
    createTaskComment,
    getTaskComments,
    deleteTaskComment,
} from './tasks.action';

export const taskActions = {
    createTask,
    getTasks,
    getTaskById,
    updateTask,
    deleteTask,
    bulkUpdateTaskStatus,
    bulkAssignTask,
    bulkDeleteTasks,
    createTaskComment,
    getTaskComments,
    deleteTaskComment,
};
